// # #############################################
// # Title : Consumer Segments Info
// # Authors : Dhruv
// # Date : 15th October 2019
// # Last Modified : October 2019
// # Version : 19.10.03
// # Description : Code for consumer segments info dialogue box
// # ############################################

import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { AppBar, Typography, Grid, List, ListItem, ListItemText, Paper, IconButton, Divider, Hidden } from '@material-ui/core';
import GroupIcon from '@material-ui/icons/Group';
import CloseIcon from '@material-ui/icons/Close'
import Dialog from '@material-ui/core/Dialog';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from "highcharts";

import '../css/Dialogue.css'


const styles = theme => ({
    reflow: {


        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            flexDirection: 'column',
            height: '70%',
            width: '100%'

        }
        ,
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '40%',
            alignItems: 'center',
            justifyContent: 'space-evenly'
        }


    },

    centerPannel: {
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '0.5vw',
            minHeight: '170px',
            alignItems: 'center',
        }
        ,
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '0.5vw',
            minHeight: '170px',
            height: '80%',
            width: '94%',
            alignItems: 'center',
            justifyContent: 'space-evenly'
        }
    }


})



const customerSegments = ["Beginnings", "Taking Hold", "Transition Time", "Flying Solo", "Family Focused", "Mixed Singles",
    "Cash & Careers", "Jumbo Families", "Middling Singles", "Mixed Middlers", "Fortunes & Families", "Flush Families", "True Blues", "Our Turn", "Mature Wealth", "Aging Upscale", "Modest Means", "Mature Rustics"
    , "Golden Years", "Active Elders", "Leisure Buffs"]

const segmentDetails = {

    "Default": {
        'Segment': 'About',
        "About": ' Select a consumer segment on the left to know more about each segment'
    },

    "Beginnings": {
        "Segment": 'Beginnings',
        "About": ' “Beginnings,” include many of those in the first generation to grow up in a wired world, making intensive use of cell phones, computers and the Internet.Demographically, they rank in the top 10 for short residential tenure, with low household incomes and minimal net worth. Except for cluster 39, they have few or no children. Theyshare some behavioral telltales, ranging from educational loans to PC and video games, no-interest checking accounts, bar-hopping and an active interest in sports. The men prefermagazines about music and style; the women about glamour, fashion and brides.',
        'Image': ''
    },

    "Taking Hold": {
        "Segment": 'Taking Hold',
        "About": '“Taking Hold,” are still under the age'
            + ' of 30 and fall into the “Security” cohort of financially comfortable young adults. The big leap'
            + ' for this cluster is not age but money, for these clusters have already made it into the middle'
            + ' and upper-middle income brackets. As a group, they are in similar entry-level white collar'
            + ' professional and technical occupations, but otherwise vary, with some clusters being single'
            + ' while others are married, and some just getting into their first homes while others are still'
            + ' renting. They are an active bunch, participating in a variety of fitness and recreational activities.'
            + ' They spend money on items for themselves, their children or their friends’ children.',
        "Image": ''
    },

    "Transition Time": {
        "Segment": 'Transition Time',
        "About": ' “Transition Time,” are firmly established groups of young'
            + ' adults born from approximately 1965 to 1981. They were mostly too young to remember'
            + ' much of the Vietnam War other than the after-effects. The members of this cluster emerged'
            + ' from school to find a lean and competitive job market. They did menial work and coasted'
            + ' through the singles bars during their 20s. Today, in their 30s and 40s, they are finally'
            + ' transitioning to a more settled lifestyle, some getting married and a few starting families.'
            + ' These clusters show a mix of white- and blue-collars, all with mid-scale household incomes,'
            + ' below-average college educations and lower than average net worth.',
        'Image': ''
    },

    "Flying Solo": {
        "Segment": 'Flying Solo',
        "About": ' “Flying Solo,” are composed of single households'
            + ' without children, including two more youthful clusters (early 30s) and one that is slightly'
            + ' older (average age of 40). Beyond age, these clusters share several key characteristics,'
            + ' including low-middle to lower socio-economic levels and a high incidence of apartment'
            + ' dwellers. They have few investments of any kind and are, in fact, just setting up their'
            + ' savings accounts. In addition to these similarities, they lead an active social life, often'
            + ' engaging in team sports and enjoying a vibrant night-life filled with dancing, concerts'
            + ' and bars.',
        'Image': ''
    },

    'Family Focused': {
        'Segment': 'Family Focused',
        'About': ' “Family Focused,” is one of the only seven clusters with children in'
            + ' which the mean household age is under 40, further underscoring the dramatic 10-year'
            + ' delay in all phases of child bearing, raising and launching over the last several decades.'
            + ' Despite differences in income, they both have low net worth, falling in the bottom third of'
            + ' the nation. Shopping seems to indicate that this group’s life stage focuses family'
            + ' resources toward meeting the needs of children, including clothing, shoe and toy'
            + ' purchases as well as children’s vitamins and cough syrups. Family-based activities and'
            + ' media preferences are also very similar between the two clusters.',
        'Image': ''
    },

    'Mixed Singles': {
        'Segment': 'Mixed Singles',
        'About': '“Mixed Singles,” struggle with some of the lowest'
            + ' incomes and often little more than minimal savings or investments; all occupy the lowest'
            + ' rungs of the socio-economic ladder. It should be noted, however, that all three have high'
            + ' concentrations of students when compared to national averages. All depend on low'
            + ' echelon, white-collar and blue-collar jobs, often part-time. Members of this life stage'
            + ' group have no children. This group shows strong urbanicity, two clusters extremely'
            + ' urban and one moderately dense.',
        'Image': ''
    },

    'Cash & Careers': {
        'Segment': 'Cash & Careers',
        'About': ' “Cash & Careers,” are some of the more affluent of the'
            + ' generation of adults born in the mid-1960’s to early ‘80s. Often self-described as “habitual'
            + ' havers” or “buyers of the best”, these cohorts, half heading up single households, are typically'
            + ' earning incomes of $70,000 plus from professional and technical positions. Today, members'
            + ' of the group are childless at 38. Led by the affluence of cluster 6, they all show high'
            + ' household incomes and home values, as well as college educations and expenditures in line'
            + ' with upper incomes. Into health and wellness, perhaps to balance their stressful work lives,'
            + ' these cohorts also know how to relax through their active social lives. Many are aggressive'
            + ' investors who have just begun to engage the market and all seem committed to enjoying the'
            + ' good life.',
        'Image': ''
    },

    'Jumbo Families': {
        'Segment': 'Jumbo Families',
        'About': ' “Jumbo Families,” is the most prolific of all clusters'
            + ' Most of those belonging to this life stage group were too young to be drafted into Vietnam, but all matured in its'
            + ' shadow. These clusters share above-average college educations and household incomes'
            + ' and have uniformly high incidence of working women, with some groups for'
            + ' blue collars. All being family-centric, they all share in relatively similar media choices,'
            + ' recreation and shopping habits.',
        'Image': ''
    },

    'Middling Singles': {
        'Segment': 'Middling Singles',
        'About': '“Middling Singles,” is a middle-aged group ranging in age from 30–45, all are'
            + ' unmarried—some perhaps divorced—and have no children at home. Most own their own'
            + ' houses, be them in the most metro areas of the U.S. or the slightly smaller, but still densely'
            + ' populated, cities and surrounds. They rank from the middle to near the bottom in income, but'
            + ' cluster 29 is within the top half of net worth rankings. Given their single status, they tend to'
            + ' spend money on themselves from designer clothes and expensive toys to foreign travel.',
        'Image': ''
    },

    'Mixed Middlers': {
        'Segment': 'Mixed Middlers',
        'About': ' “Mixed Middlers,” exemplify the price of divorces in'
            + ' America Those who, with or without children, must manage on limited educations and'
            + ' incomes. Assuming a majority of this cohort did not marry before 30, then, per current'
            + ' American norms, the "Mixed Middlers" cluster—many in their early 40s—are right on schedule. Divorced'
            + ' or not, they are clearly unique—two clusters are rural, one dense metro, and they all rank'
            + ' differently on the socio-economic scale. What do they have in common? All show'
            + ' predominant clerical white-collar and blue-collar occupations, with limited educations,'
            + ' most are single, and all have below average net worth.',
        'Image': ''
    },

    'Fortunes & Families': {
        'Segment': 'Fortunes & Families',
        'About': '“Fortunes & Families,” is made up of top breadwinners who enjoy a luxurious'
            + ' lifestyle with their families.Money on this scale is chiefly found where big money is made,'
            + ' traded or banked; thus, they are primarily concentrated in the New England,'
            + ' Mid-Atlantic and Pacific regions of the U.S. These clusters enjoy peak education levels for'
            + ' both sexes, upper white-collar jobs, working women and dual incomes. All the trappings of'
            + ' wealth are here, including luxury homes and autos, travel, investment portfolios and costly'
            + ' leisure activities.',
        'Image': ''
    },

    'Flush Families': {
        'Segment': 'Flush Families',
        'About': '“Flush Families,” covers both married and single parents. They are quite similar —'
            + ' well educated, employed in white-collar occupations, with upper-middle to affluent incomes'
            + ' and net worth. All are parents of older school-age children; reside in upscale, mortgaged'
            + ' homes in the metro fringes of the nation’s major DMAs; and are absorbed in the lifestyles'
            + ' dictated by parental roles.',
        'Image': ''
    },

    "True Blues": {
        "Segment": 'True Blues',
        "About": '“True Blues,” contain two of the top ten dominant blue'
            + ' collar bastions in America, featuring working families with mostly teenaged children.'
            + ' When these parents were born, the term “blue collar” identified those who made and'
            + ' built things with hands and tools—over a third of all jobs. Today, blue collars make up less'
            + ' than 15% of U.S. occupations, but not in "True Blues", where they are dominant at 30-38%.'
            + ' They favor big families, outdoor activities and pickup trucks.',
        "Image": ''
    },

    "Our Turn": {
        "Segment": 'Our Turn',
        "About": '“Our Turn,” features a cross-section of America’s shifting middle-age cohort'
            + ' who today share mean ages between 45 and 65. Though they share mid- to upper-middle'
            + ' household incomes,their differences far outweigh similarities—two clusters are comprised of'
            + ' single people, three clusters are married, and there are wide disparities in home ownership,'
            + ' population densities and net worth.',
        'Image': ''
    },

    "Mature Wealth": {
        "Segment": 'Mature Wealth',
        "About": '“Mature Wealth” exhibit peak wealth, generated from'
            + ' cohorts who span between the ages of 46 and 75. As expected, such households are often'
            + ' to be found where most large fortunes are made, resulting in these clusters being highly'
            + ' concentrated in the most costly MSAs and watering holes of New England, the Mid-Atlantic'
            + ' and Pacific. They quite literally do and buy everything. Very rich, they indulge themselves in'
            + ' what one might expect: fitness clubs, investments, financial advisors, luxury automobiles,'
            + ' business magazines, leisure activities, charities and foreign travel.',
        'Image': ''
    },

    'Aging Upscale': {
        'Segment': 'Aging Upscale',
        'About': '“Aging Upscale,” is partly comprised of many from the so-called Vietnam cohort,'
            + ' who, as young adults at the outset of the war, were some of the first to be drafted, and the'
            + ' last to attend. The other part of this cohort, coming of age just after the pull-out of U.S.'
            + ' ground forces. Much of this cohort was also the last to marry young, so they all may be'
            + ' characterized as “empty nest.” Two of the clusters are married, while one is not. While'
            + ' educations vary above and below average, none would be considered low by age group.'
            + ' Without exception, the “Aging Upscale” group lives well, pursuing activities and interests'
            + ' suited to their separate milieus and economic strata.',
        'Image': ''
    },

    'Modest Means': {
        'Segment': 'Modest Means',
        'About': '“Modest Means,” represents those who were young adults, some of draft age,'
            + ' during the rapid buildup of American troops in Vietnam. This clusters, with their high singles rates suggest a fairly'
            + ' high incidence of divorces and/or widows. They are mostly homeowners, with above-average'
            + ' residential tenures and equity ratios. Overall, these clusters fall into the low mid and lower socio'
            + ' economic strata. While the group as a whole is about average for a college education, there is a'
            + ' high incidence for clerical white collar and blue-collar occupations, which have the effect of'
            + ' limiting household incomes. Most own only one car that they like to take care of themselves as'
            + ' much as possible and shop discount stores for bargains for their modest homes.',
        'Image': ''
    },

    'Mature Rustics': {
        'Segment': 'Mature Rustics',
        'About': '“Mature Rustics,” is comprised of  blue-collar dominated clusters, with'
            + ' some moving toward retirement. They represent what might be called the last mainstay of'
            + ' old-fashioned, stubborn country values. They are strikingly similar in their rustic locales'
            + ' and lifestyles, sharing very high concentrations outside of small second cities throughout'
            + ' the Central and Southern regions. High school educations are at or above the national'
            + ' incidence, and incomes are all below average. However, blessed by the nation’s lowest'
            + ' costs of living and nearly all being homeowners, they all have accrued some net worth,'
            + ' landing them in the middle of the national rankings. The majority of these households'
            + ' enjoy a rural lifestyle, participating in outdoor activities, driving pickup trucks and'
            + ' attending NASCAR races.',
        'Image': ''
    },

    'Golden Years': {
        'Segment': 'Golden Years',
        'About': '"Golden Years," exemplify one of the great American'
            + ' dreams: having the option for early, healthy retirement among chosen peers in attractive,'
            + ' stress-free settings. Of the three, only 38% of cluster 09 is retired; the other two are still'
            + ' employed in upscale, white-collar occupations and still raking in the dough. As a group,'
            + ' they share a great many characteristics, such as top 10 educations and net worth,'
            + ' comparable investment patterns, ownership of valuable real estate, personal luxury cars,'
            + ' wholesale involvement in clubs and organizations, and preoccupation with the full'
            + ' spectrum of good-life activities including travel abroad.',
        'Image': ''
    },

    'Active Elders': {
        'Segment': 'Active Elders',
        'About': '“Active Elders,” share several advantages of comfortable retirement.'
            + ' They enjoy solid middle to upper middle incomes, are educated well above their peers, rank'
            + ' among the top 25 clusters for residential tenure, and, as homeowners, rank high in average ratios'
            + ' of available equity-to-home values. With mean ages as high as 76+ years, there is a mix of widows'
            + ' and widowers, and observable patterns of health consciousness and conservatism in all things,'
            + ' including spending, eating and investments. They are very likely to be members of several social'
            + ' and church groups and dote on family and grandchildren. They tend to own a domestic luxury car.',
        'Image': ''
    },

    'Leisure Buffs': {
        'Segment': 'Leisure Buffs',
        'About': '“Leisure Buffs,” claim less than half of the household income'
            + ' and education levels enjoyed by the seniors in "Active Elders", but resemble them on several'
            + ' other counts. Their advanced mean ages ranging from 66 to 76+ years, mix of widows,'
            + ' health consciousness (many being reliant on Medicare) and fiscal conservatism are'
            + ' similar. They appear to enjoy socializing via various organizations or clubs such as'
            + ' veterans clubs, fraternal orders, and religious organizations. They are travel-prone, with'
            + ' most staying close to home for their excursions or going on guided tours. They also'
            + ' enjoy activities centered on homes, gardens and quiet pastimes such as playing bingo'
            + ' and working crossword puzzles, collecting, needlework and sewing. They tend to have a'
            + ' slightly older mid-range Buick or Chrysler car. They prefer early and weekend TV news'
            + ' and talk shows as well as lots of game shows.',
        'Image': ''
    },


}

let optionsChannel = {
    chart: {
        reflow: true,
        backgroundColor: 'transparent',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        type: 'column',
        height: '50%'
    },
    title: {
        text: ' ',
        y: 10,
        style: {
            fontSize: 'calc(1px + 0.4vw + 0.1vh)',
            fontFamily: 'Roboto'
        }
    },

    xAxis: {
        gridLineColor: '#ffffff',
        lineColor: '#ffffff',
        type: 'category',
        labels: {
            style: {
                fontSize: '8px',
                fontFamily: 'Roboto'
            }
        }
    },
    yAxis: {
        gridLineColor: '#ffffff',
        lineColor: '#ffffff',
        labels: {
            enabled: false
        },
        min: 0,
        title: {
            text: null
        }
    },
    legend: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    tooltip: {
        pointFormat: 'Percentage of users: <b>{point.y:.0f} %</b>'
    },
    series: [{
        color: '#56BCCD',
        groupPadding: 0,
        name: 'Percentage',
        data: [],
        dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#FFFFFF',
            textOutline: null,
            align: 'right',
            format: '{point.y:.1f}', // one decimal
            y: 15, // 10 pixels down from the top
            style: {
                fontSize: '12px',
                fontFamily: 'Verdana, sans-serif',
                textOutline: "0px contrast"
            }
        }
    }],

}

let donutOptions = {
    chart: {
        reflow: true,
        backgroundColor: 'transparent',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '100%',

    },
    legend: {
        enabled: false,
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        itemStyle: {
            fontSize: '8px'
        },
    },
    title: {
        text: ``,
        style: {
            fontSize: '15px',
            fontWeight: 'bold'
        }
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        pie: {

            showInLegend: true,
            colors: ['#666666', '#bbbbbb'],
            dataLabels: {
                connectorWidth: 0,
                enabled: false,
                distance: "-22%",
                format: '{point.y}%',
                style: {
                    fontWeight: '1px',
                    color: 'black',
                    fontSize: '12px',
                    textOutline: '0px'

                }
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '15'],
            size: '80',
            borderWidth: 0,
        }
    },
    series: [{
        type: 'pie',
        name: 'Percentage',
        innerSize: '70%',
        data: [
            ["Married", 62],
            ["Unmarried", 38]
        ]
    }]
}


let segmentActivity = [
    {
        "segment": "active elders",
        "Commute": 0,
        "Entertainment": 63.1682518858642,
        "Fitness": 0,
        "Hygiene": 10.6592325352575,
        "Interactions": 26.1725155788783,
        "Work": 0,
        "total": 100
    },
    {
        "segment": "aging upscale",
        "Commute": 3.7037037037037,
        "Entertainment": 32.1321321321321,
        "Fitness": 2.1021021021021,
        "Hygiene": 6.50650650650651,
        "Interactions": 13.3133133133133,
        "Work": 42.2422422422422,
        "total": 100
    },
    {
        "segment": "beginnings",
        "Commute": 3.07053941908714,
        "Entertainment": 39.9585062240664,
        "Fitness": 0,
        "Hygiene": 5.39419087136929,
        "Interactions": 16.5560165975104,
        "Work": 35.0207468879668,
        "total": 100
    },
    {
        "segment": "cash & careers",
        "Commute": 3.66518078256563,
        "Entertainment": 31.7979197622585,
        "Fitness": 3.12035661218425,
        "Hygiene": 6.43883110450718,
        "Interactions": 13.1748390292224,
        "Work": 41.802872709262,
        "total": 100
    },
    {
        "segment": "family focused",
        "Commute": 3.32076826422545,
        "Entertainment": 28.8099084544965,
        "Fitness": 2.26171243941842,
        "Hygiene": 5.83378208580147,
        "Interactions": 14.3241787829833,
        "Work": 45.4496499730748,
        "total": 100
    },
    {
        "segment": "flush families",
        "Commute": 4.393429645755,
        "Entertainment": 31.7633089253909,
        "Fitness": 2.4935681773204,
        "Hygiene": 6.43182267959628,
        "Interactions": 13.1604987136355,
        "Work": 41.757371858302,
        "total": 100
    },
    {
        "segment": "flying solo",
        "Commute": 3.68305793350587,
        "Entertainment": 31.9530161258212,
        "Fitness": 0,
        "Hygiene": 6.47023691021302,
        "Interactions": 15.8869201672307,
        "Work": 42.0067688632291,
        "total": 100
    },
    {
        "segment": "fortunes & families",
        "Commute": 6.129887342611,
        "Entertainment": 53.1809145129225,
        "Fitness": 3.47912524850895,
        "Hygiene": 10.7687210072896,
        "Interactions": 26.441351888668,
        "Work": 0,
        "total": 100
    },
    {
        "segment": "golden years",
        "Commute": 0,
        "Entertainment": 42.6823863132701,
        "Fitness": 0,
        "Hygiene": 5.7619005407322,
        "Interactions": 14.1476819430902,
        "Work": 37.4080312029075,
        "total": 100
    },
    {
        "segment": "jumbo families",
        "Commute": 4.62114904246461,
        "Entertainment": 26.7277268942548,
        "Fitness": 0,
        "Hygiene": 8.11823480432972,
        "Interactions": 16.6111573688593,
        "Work": 43.9217318900916,
        "total": 100
    },
    {
        "segment": "leisure buffs",
        "Commute": 3.16077225354519,
        "Entertainment": 43.8749359302922,
        "Fitness": 0,
        "Hygiene": 5.55270801298479,
        "Interactions": 11.3616948573381,
        "Work": 36.0498889458397,
        "total": 100
    },
    {
        "segment": "mature rustics",
        "Commute": 3.63029827315542,
        "Entertainment": 25.1962323390895,
        "Fitness": 2.06043956043956,
        "Hygiene": 6.37755102040816,
        "Interactions": 13.0494505494505,
        "Work": 49.6860282574568,
        "total": 100
    },
    {
        "segment": "mature wealth",
        "Commute": 5.20980005632216,
        "Entertainment": 24.1058856660096,
        "Fitness": 0,
        "Hygiene": 6.10156763353046,
        "Interactions": 24.9694921618323,
        "Work": 39.6132544823055,
        "total": 100
    },
    {
        "segment": "middling singles",
        "Commute": 5.1308126097809,
        "Entertainment": 35.610612924101,
        "Fitness": 1.94138855505223,
        "Hygiene": 6.00905981325691,
        "Interactions": 12.2954608486641,
        "Work": 39.0126652491449,
        "total": 100
    },
    {
        "segment": "mixed middlers",
        "Commute": 3.46182634730539,
        "Entertainment": 36.0404191616766,
        "Fitness": 0,
        "Hygiene": 6.0815868263473,
        "Interactions": 14.9326347305389,
        "Work": 39.4835329341317,
        "total": 100
    },
    {
        "segment": "mixed singles",
        "Commute": 2.89107673073918,
        "Entertainment": 30.098452883263,
        "Fitness": 0,
        "Hygiene": 5.07891858102829,
        "Interactions": 12.4706985466479,
        "Work": 49.4608532583216,
        "total": 100
    },
    {
        "segment": "modest means",
        "Commute": 3.5423647678315,
        "Entertainment": 30.7324078506462,
        "Fitness": 0,
        "Hygiene": 6.22307324078506,
        "Interactions": 19.1000478697942,
        "Work": 40.402106270943,
        "total": 100
    },
    {
        "segment": "our turn",
        "Commute": 3.55018230665899,
        "Entertainment": 36.9602763385147,
        "Fitness": 0,
        "Hygiene": 6.23680675494147,
        "Interactions": 12.7614661293418,
        "Work": 40.4912684705431,
        "total": 100
    },
    {
        "segment": "taking hold",
        "Commute": 3.68819776714514,
        "Entertainment": 31.9976076555024,
        "Fitness": 2.51196172248804,
        "Hygiene": 6.4792663476874,
        "Interactions": 13.2575757575758,
        "Work": 42.0653907496013,
        "total": 100
    },
    {
        "segment": "transition time",
        "Commute": 3.48268072289157,
        "Entertainment": 30.2146084337349,
        "Fitness": 0,
        "Hygiene": 6.11822289156626,
        "Interactions": 12.5188253012048,
        "Work": 47.6656626506024,
        "total": 100
    },
    {
        "segment": "true blues",
        "Commute": 4.35499058380414,
        "Entertainment": 22.6694915254237,
        "Fitness": 0,
        "Hygiene": 7.65065913370998,
        "Interactions": 15.6544256120527,
        "Work": 49.6704331450094,
        "total": 100
    }
]

const segmentData = [
    {
        "Group name": "Beginnings",
        "Urbanicity": "city.jpg",
        "Activity": "trekking.jpg",
        "Logo": "customer_segment/profile_image/beginnings.jpg",
        "Percentage": "5.05%",
        "Married": 24.9,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 35.6
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 63.6
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0.8
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 0
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 0
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ],

        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 25.2
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 11.9
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 20.4
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 24.2
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 6.4
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 6.2
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 1.8
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0.6
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 3.3
            }
        ]
    },
    {
        "Group name": "Taking Hold",
        "Urbanicity": "suburbs.jpg",
        "Activity": "cooking.jpg",
        "Logo": "customer_segment/profile_image/taking hold.jpg",
        "Percentage": "4.08%",
        "Married": 52.6,
        "Location": "customer_segment/location/suburbs.jpg",
        "LocationPlaceholder": "Suburbs & Towns",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 10.4
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 73.7
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 15.8
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 0.2
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 0
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0.4
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 1
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 1.6
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 17.2
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 46.7
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 21.9
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 3.4
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 7.5
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]

    },
    {
        "Group name": "Transition Time",
        "Urbanicity": "rural.jpg",
        "Activity": "motorcycle riding.jpg",
        "Logo": "customer_segment/profile_image/transition time.jpg",
        "Percentage": "2.69%",
        "Married": 87.3,
        "Location": "customer_segment/location/rural.jpg",
        "LocationPlaceholder": "Rural",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0.2
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 5.4
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 35
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 59.4
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 0
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],

        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 7.1
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 6.4
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 16
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 22.1
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 26.9
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 16.3
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 4
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 1.1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Flying Solo",
        "Urbanicity": "city.jpg",
        "Activity": "gaming.jpg",
        "Logo": "customer_segment/profile_image/flying solo.jpg",
        "Percentage": "3.29%",
        "Married": 6.2,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0.9
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 11.1
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 56.4
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 30.5
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 1.1
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 13.5
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 10
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 20.1
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 28.3
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 27.8
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.3
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Family Focused",
        "Urbanicity": "city.jpg",
        "Activity": "cooking.jpg",
        "Logo": "customer_segment/profile_image/family focused.jpg",
        "Percentage": "3.74%",
        "Married": 68.4,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 33.5
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 56.3
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 8.1
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 2.1
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 23.1
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 9.1
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 19.5
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 23.9
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 24.5
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Mixed Singles",
        "Urbanicity": "city.jpg",
        "Activity": "soccer.jpg",
        "Logo": "customer_segment/profile_image/mixed singles.jpg",
        "Percentage": "2.54%",
        "Married": 14.3,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 6.4
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 23.1
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 21.8
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 45.6
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 3.1
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 67.9
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 4.9
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 4.9
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 6.1
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 5.1
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 7.7
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 1.4
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 2
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },

    {
        "Group name": "Cash & Careers",
        "Urbanicity": "suburbs.jpg",
        "Activity": "gambling.jpg",
        "Logo": "customer_segment/profile_image/cash & careers.jpg",
        "Percentage": "5.46%",
        "Married": 36.6,
        "Location": "customer_segment/location/suburbs.jpg",
        "LocationPlaceholder": "Suburbs & Towns"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0.1
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 2.7
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 26.9
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 69
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 1.3
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 48.7
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 26.9
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 11.9
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 3.4
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 9.1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Jumbo Families",
        "Urbanicity": "suburbs.jpg",
        "Activity": "tennis.jpg",
        "Logo": "customer_segment/profile_image/jumbo families.jpg",
        "Percentage": "6.54%",
        "Married": 94.0,
        "Location": "customer_segment/location/suburbs.jpg",
        "LocationPlaceholder": "Suburbs & Towns"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0.7
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 23.4
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 60.6
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 11.7
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 3.1
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0.4
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 0.1
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 55.4
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 35.6
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 7.2
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0.7
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.7
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Middling Singles",
        "Urbanicity": "city.jpg",
        "Activity": "yoga.jpg",
        "Logo": "customer_segment/profile_image/middling singles.jpg",
        "Percentage": "1.68%",
        "Married": 3,
        "Location": "customer_segment/location/downtown.jpg",
        "LocationPlaceholder": "Downtown Metro"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 1.2
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 12.6
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 79.7
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 3.9
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 2.6
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 0
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0.1
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 7.5
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 24.8
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 22.2
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 23.9
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 9.1
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 7.7
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 3.2
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 1.3
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Mixed Middlers",
        "Urbanicity": "rural.jpg",
        "Activity": "watching movie.jpg",
        "Logo": "customer_segment/profile_image/mixed middlers.jpg",
        "Percentage": "4.31%",
        "Married": 3.2,
        "Location": "customer_segment/location/rural.jpg",
        "LocationPlaceholder": "Rural",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0.2
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 17.5
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 37.2
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 30
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 13.9
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 1.2
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 15.2
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 7.4
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 15.4
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 22.5
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 24.8
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 14.1
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0.2
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0.1
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.3
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Fortunes & Families",
        "Urbanicity": "suburbs.jpg",
        "Activity": "tennis.jpg",
        "Logo": "customer_segment/profile_image/fortunes & families.jpg",
        "Percentage": "6.14%",
        "Married": 90.6,
        "Location": "customer_segment/location/suburbs.jpg",
        "LocationPlaceholder": "Suburbs & Towns"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0.3
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 1
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 4.8
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 34.2
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 41.1
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 13.6
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 3.3
            },
            {
                "AgeGroup": "76+",
                "Percentage": 1.7
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0.1
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 0.2
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 1.4
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 2.7
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 27.7
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 37.3
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 30.6
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Flush Families",
        "Urbanicity": "city.jpg",
        "Activity": "beach.jpg",
        "Logo": "customer_segment/profile_image/flush families.jpg",
        "Percentage": "6.98%",
        "Married": 49.7,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 1.4
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 7.4
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 20.3
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 49.9
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 18.8
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 2.1
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 0.1
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 0.1
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 55.2
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 38.9
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 5.5
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "True Blues",
        "Urbanicity": "city.jpg",
        "Activity": "gardening.jpg",
        "Logo": "customer_segment/profile_image/true blues.jpg",
        "Percentage": "3.5%",
        "Married": 97.2,
        "Location": "customer_segment/location/rural.jpg",
        "LocationPlaceholder": "Rural",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 3.6
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 17.1
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 50.7
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 27.5
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 1.2
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 14.2
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 7.4
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 17.4
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 27.6
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 32.7
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 0.4
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Our Turn",
        "Urbanicity": "downtown.jpg",
        "Activity": "sewing.jpg",
        "Logo": "customer_segment/profile_image/our turn.jpg",
        "Percentage": "5.26%",
        "Married": 64.3,
        "Location": "customer_segment/location/downtown.jpg",
        "LocationPlaceholder": "Downtown Metro"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0.1
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 1.3
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 5.4
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 65.6
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 22
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 5.2
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0.5
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0.4
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 1.6
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 7.2
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 22.9
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 42.2
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 22.4
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 1.7
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 1.1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Mature Wealth",
        "Urbanicity": "city.jpg",
        "Activity": "charity.jpg",
        "Logo": "customer_segment/profile_image/mature wealth.jpg",
        "Percentage": "3.98%",
        "Married": 79.4,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0.1
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 1.3
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 5.4
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 65.6
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 22
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 5.2
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0.5
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0.4
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 1.6
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 7.2
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 22.9
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 42.2
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 22.4
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 1.7
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 1.1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Retired"
        ]
    },
    {
        "Group name": "Aging Upscale",
        "Urbanicity": "city.jpg",
        "Activity": "reading.jpg",
        "Logo": "customer_segment/profile_image/aging upscale.jpg",
        "Percentage": "4.66%",
        "Married": 56.3,
        "Location": "customer_segment/location/rural.jpg",
        "LocationPlaceholder": "Rural",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0.1
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 0.5
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 41
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 55.9
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 2.4
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0.1
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 57.9
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 31.5
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 10.3
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.3
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Modest Means",
        "Urbanicity": "downtown.jpg",
        "Activity": "veteran clubs.jpg",
        "Logo": "customer_segment/profile_image/modest means.jpg",
        "Percentage": "4.91%",
        "Married": 36.8,
        "Location": "customer_segment/location/suburbs.jpg",
        "LocationPlaceholder": "Suburbs & Towns"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 0.3
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 48.9
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 47.3
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 3.4
            },
            {
                "AgeGroup": "76+",
                "Percentage": 0.1
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 27
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 10.1
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 24.1
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 26.6
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 12.2
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Mature Rustics",
        "Urbanicity": "rural.jpg",
        "Activity": "gardening.jpg",
        "Logo": "customer_segment/profile_image/mature rustics.jpg",
        "Percentage": "3.54%",
        "Married": 74.4,
        "Location": "customer_segment/location/rural.jpg",
        "LocationPlaceholder": "Rural",
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 1.2
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 22
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 25
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 26.9
            },
            {
                "AgeGroup": "76+",
                "Percentage": 25
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 11.2
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 10.9
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 20.1
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 24.5
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 23.1
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 9.4
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.3
            }
        ],
        "Occupation": [
            "Professional/Technical", "Craftsman/Blue Collar", "Retired"
        ]
    },
    {
        "Group name": "Golden Years",
        "Urbanicity": "suburbs.jpg",
        "Activity": "walking.jpg",
        "Logo": "customer_segment/profile_image/golden years.jpg",
        "Percentage": "6.01%",
        "Married": 74.6,
        "Location": "customer_segment/location/suburbs.jpg",
        "LocationPlaceholder": "Suburbs & Towns"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0.1
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0.2
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 1.9
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 23.2
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 33.7
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 22.8
            },
            {
                "AgeGroup": "76+",
                "Percentage": 18.2
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 0.9
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 0.3
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 1.4
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 4.4
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 6.5
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 24.6
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 24.1
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 24
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 6.9
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 6.9
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Craftsman/Blue Collar"
        ]
    },
    {
        "Group name": "Active Elders",
        "Urbanicity": "city.jpg",
        "Activity": "golf.jpg",
        "Logo": "customer_segment/profile_image/active elders.jpg",
        "Percentage": "7.51%",
        "Married": 60.6,
        "Location": "customer_segment/location/city.jpg",
        "LocationPlaceholder": "City & Surrounds"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 0
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 0
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 49.2
            },
            {
                "AgeGroup": "76+",
                "Percentage": 50.8
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 7.6
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 4.1
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 5.3
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 8.4
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 12.1
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 38.8
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 16.6
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 6
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Clerical/White Collar", "Retired"
        ]
    },
    {
        "Group name": "Leisure Buffs",
        "Urbanicity": "suburbs.jpg",
        "Activity": "solving crosswords.jpg",
        "Logo": "customer_segment/profile_image/leisure buffs.jpg",
        "Percentage": "8.12%",
        "Married": 44.3,
        "Location": "customer_segment/location/downtown.jpg",
        "LocationPlaceholder": "Downtown Metro"
        ,
        "AgeData": [
            {
                "AgeGroup": "18-23",
                "Percentage": 0
            },
            {
                "AgeGroup": "24-29",
                "Percentage": 0
            },
            {
                "AgeGroup": "30-35",
                "Percentage": 0
            },
            {
                "AgeGroup": "36-45",
                "Percentage": 0
            },
            {
                "AgeGroup": "46-55",
                "Percentage": 0
            },
            {
                "AgeGroup": "56-65",
                "Percentage": 0
            },
            {
                "AgeGroup": "66-75",
                "Percentage": 41.6
            },
            {
                "AgeGroup": "76+",
                "Percentage": 58.4
            }
        ],
        "IncomeData": [
            {
                "IncomeGroup": "<15K",
                "Percentage": 34.1
            },
            {
                "IncomeGroup": "~20K",
                "Percentage": 17.3
            },
            {
                "IncomeGroup": "~30K",
                "Percentage": 22.5
            },
            {
                "IncomeGroup": "~40K",
                "Percentage": 16.4
            },
            {
                "IncomeGroup": "~50K",
                "Percentage": 9.2
            },
            {
                "IncomeGroup": "~75K",
                "Percentage": 0.4
            },
            {
                "IncomeGroup": "~100K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~125K",
                "Percentage": 0
            },
            {
                "IncomeGroup": "~150K",
                "Percentage": 0
            },
            {
                "IncomeGroup": ">150K",
                "Percentage": 0.1
            }
        ],
        "Occupation": [
            "Professional/Technical", "Housewife", "Retired"
        ]
    },
]

const StyledListItemText = withStyles(theme => ({

    root: {
        paddingRight: '0px !important'
    }


}))(ListItemText)

const StyledDivider = withStyles(theme => ({

    middle: {
        height: '1px',
        width: 'calc(3vw + 4vh)',
        background: '#e5e5e5'
    }

}))(Divider)

const channelProbability =
    [
        {
            "Media": "beginnings",
            "digitalmedia": 0.61,
            "printmedia": 0.03,
            "tv": 0.16,
            "billboard": 0.04,
            "radio": 0.13,
            "none": 0.03
        },
        {
            "Media": "transition time",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "flying solo",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "family focused",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "mixed singles",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "middling singles",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "mixed middlers",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "true blues",
            "digitalmedia": 0.24,
            "printmedia": 0.1,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.16,
            "none": 0.02
        },
        {
            "Media": "modest means",
            "digitalmedia": 0.24,
            "printmedia": 0.1,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.16,
            "none": 0.02
        },
        {
            "Media": "mature rustics",
            "digitalmedia": 0.16,
            "printmedia": 0.18,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.14,
            "none": 0.04
        },
        {
            "Media": "leisure buffs",
            "digitalmedia": 0.16,
            "printmedia": 0.18,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.14,
            "none": 0.04
        },
        {
            "Media": "taking hold",
            "digitalmedia": 0.61,
            "printmedia": 0.03,
            "tv": 0.16,
            "billboard": 0.04,
            "radio": 0.13,
            "none": 0.03
        },
        {
            "Media": "our turn",
            "digitalmedia": 0.3,
            "printmedia": 0.2,
            "tv": 0.2,
            "billboard": 0.1,
            "radio": 0.1,
            "none": 0.1
        },
        {
            "Media": "jumbo families",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "flush families",
            "digitalmedia": 0.24,
            "printmedia": 0.1,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.16,
            "none": 0.02
        },
        {
            "Media": "aging upscale",
            "digitalmedia": 0.24,
            "printmedia": 0.1,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.16,
            "none": 0.02
        },
        {
            "Media": "golden years",
            "digitalmedia": 0.16,
            "printmedia": 0.18,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.14,
            "none": 0.04
        },
        {
            "Media": "active elders",
            "digitalmedia": 0.16,
            "printmedia": 0.18,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.14,
            "none": 0.04
        },
        {
            "Media": "cash & careers",
            "digitalmedia": 0.41,
            "printmedia": 0.05,
            "tv": 0.23,
            "billboard": 0.09,
            "radio": 0.19,
            "none": 0.03
        },
        {
            "Media": "fortunes & families",
            "digitalmedia": 0.24,
            "printmedia": 0.1,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.16,
            "none": 0.02
        },
        {
            "Media": "mature wealth",
            "digitalmedia": 0.24,
            "printmedia": 0.1,
            "tv": 0.38,
            "billboard": 0.1,
            "radio": 0.16,
            "none": 0.02
        }
    ]


const closedStyle = {
    color: "rgb(140, 140, 140)", fontSize: 'calc(6px + 0.4vw + 0.1vh)', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', height: '2.4em', border: '1px solid transparent', padding: '5px 5px 0px 5px', transition: "height 2s"
}

const openStyle = { color: "rgb(140, 140, 140)", fontSize: 'calc(6px + 0.4vw + 0.1vh)', border: '1px solid transparent', padding: '5px 5px 0px 5px', transition: "height 2s" }


class ConsumerSegmentsDialogue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSegment: 'Active Elders',
            openPannel: false,
            Married: 60.6,
            expandText: "More .."
        }
    }

    onSelect = (segment) => {

        this.setState({
            selectedSegment: segment
        })

        this.setMarried(segment)

    }

    setMarried(segment) {
        this.setState({
            Married: segmentData.filter(a => a["Group name"] === segment)[0].Married
        })
    }

    renderChart1(enableLegend, title = null, data) {


        let chartoptions = JSON.parse(JSON.stringify(optionsChannel))
        chartoptions.series[0].data = data[0]
        chartoptions.legend.enabled = enableLegend
        chartoptions.title.text = title

        return (
            <div style={{ width: '100%', height: '100%' }}>
                <HighchartsReact highcharts={Highcharts} options={chartoptions} />
            </div>
        )
    }

    renderChart2(enableLegend, title = null, data) {

        let chartoptions = JSON.parse(JSON.stringify(donutOptions))
        chartoptions.series[0].data = data[0]
        chartoptions.title.text = title
        chartoptions.legend.enabled = enableLegend
        chartoptions.plotOptions.pie.startAngle = null
        chartoptions.plotOptions.pie.endAngle = null
        chartoptions.series[0].innerSize = '70%'
        chartoptions.plotOptions.pie.colors = ['#4596a4', '#56bccd', '#78c9d7', '#9ad7e1', '#bbe4eb', '#ddf2f5']
        chartoptions.title.style = { fontSize: 'calc(1px + 0.4vw + 0.1vh)' }
        chartoptions.legend.itemMarginBottom = 3
        chartoptions.legend.itemStyle.fontSize = '9px'

        return (
            <div style={{ width: '100%', height: '100%' }}>
                <HighchartsReact highcharts={Highcharts} options={chartoptions} />
            </div>
        )
    }

    renderPie(data) {
        let chartoptions = JSON.parse(JSON.stringify(donutOptions))
        chartoptions.series[0].data = data

        return (
            <HighchartsReact highcharts={Highcharts} options={chartoptions} />
        )
    }



    expandPannel(v) {
        this.setState({
            openPannel: !v
        })

        if (this.state.openPannel) {
            this.setState({
                expandText: 'More...'
            })
        }

        else {
            this.setState({
                expandText: '...Less'
            })
        }
    }

    render() {
        console.log(`selected segment: ${this.state.selectedSegment}`)
        return (
            <Dialog
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={this.props.maxWidth}
                fullWidth={true}
                style={{ fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif" }}
            >
                <AppBar position="static" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: 'rgb(53, 168, 189, 0.77)', padding: '10px', boxShadow: 'none', height: 'calc(1vw + 5vh)' }} >
                    <GroupIcon color='inherit' style={{ padding: '0 20px', minHeight: 'calc(15px + 1vw + 1vh)', minWidth: 'calc(15px + 1vw + 1vh)' }} />
                    <Typography color="inherit" align="left" style={{ display: 'flex', flexGrow: 1, fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif', fontSize: 'calc(15px + 0.4vw + 0.1vh)' }} >Consumer Segments</Typography>
                    <IconButton edge="start" color="inherit" onClick={this.props.handleClose} aria-label="close" >
                        <CloseIcon />
                    </IconButton>
                </AppBar>
                <DialogContent style={{ maxHeight: 'calc(20vw + 70vh)', padding: '0 0 calc(1vw + 1vh) calc(1vw + 1vh) ' }} >
                    <DialogContentText id="alert-dialog-description">
                        <Grid container className="grid-container" sm style={{ paddingTop: "10px" }} >
                            {/* Customer segments content area (Left column) */}
                            <Grid item className={"grid-column scrollbar"} id={"style-1"} xs={3} style={{ maxHeight: '400px' }}>
                                <Paper className={"force-overflow"} style={{ marginBottom: '10px' }}>
                                    <List component="ul" style={{ marginRight: 'calc(1vw + 1vh)', paddingBottom: '0px', paddingTop: 'calc(1vh)' }} >
                                        {customerSegments.sort().map(segment =>
                                            <Fragment>
                                                <ListItem button onClick={() => this.onSelect(segment)} style={{ padding: '0px' }} >
                                                    <StyledListItemText
                                                        disableGutters
                                                        selected={true}
                                                        primary={<Typography style={{ padding: "3px 0 3px 0", color: '#B4B4B5', fontSize: 'calc(10px + 0.4vw + 0.1vh)', textAlign: 'right' }}
                                                            variant="BUTTON TEXT">{segment}</Typography>
                                                        }
                                                    />
                                                </ListItem>
                                            </Fragment>)}
                                    </List>
                                </Paper>
                            </Grid>
                            {/* Customer segments content area (middle column) */}

                            <Grid item className={"grid-column scrollbar"} id={"style-2"} xs={7} style={{ padding: 'calc(1vh) 0px calc(1vw + 1vh) calc(1vw + 1vh)', maxHeight: '400px', borderRight: '1.5px solid #c5c5c56b ' }}>
                                <Grid container direction="column" style={{ paddingRight: 'calc(1vw + 1vh)' }} >
                                    <Grid item >
                                        <Typography style={{ padding: "5px 0 5px 0", fontSize: 'calc(11px + 0.4vw + 0.1vh)', color: "#b4b4b5", fontWeight: '400' }} variant="headline">{this.state.selectedSegment === '' || this.state.selectedSegment === undefined ? segmentDetails.Default.Segment :
                                            segmentDetails[this.state.selectedSegment].Segment}
                                        </Typography>
                                        <div>
                                            <Typography
                                                style={this.state.openPannel ? openStyle : closedStyle} align='left' variant="body1">
                                                {this.state.selectedSegment === '' || this.state.selectedSegment === undefined ? segmentDetails.Default.About : segmentDetails[this.state.selectedSegment].About}
                                            </Typography>
                                            <div className={"hoverText"} onClick={() => this.expandPannel(this.state.openPannel)}
                                                style={{
                                                    padding: "0px 0px 5px 5px",
                                                    fontSize: "calc((6px + 0.4vw) + 0.1vh)",
                                                    display: 'inline',
                                                    color: "#54BBCC"
                                                }} >
                                                {this.state.expandText}
                                            </div>

                                        </div>
                                    </Grid>
                                </Grid>

                                {this.state.selectedSegment === '' || this.state.selectedSegment === undefined ? null :
                                    <div className={this.props.classes.centerPannel}>
                                        <div className={this.props.classes.reflow}>
                                            <div className={"columnCharts"} style={{ height: '100%', width: '100%' }}>
                                                {this.renderChart1(false, "Income level Distribution",
                                                    [segmentData.filter(item => item["Group name"] === this.state.selectedSegment)[0]["IncomeData"].map(item => [item["IncomeGroup"], item.Percentage])]
                                                )}
                                            </div>
                                            <div className={"columnCharts"} style={{ height: '100%', width: '100%' }}>
                                                {this.renderChart1(false, "Age Group Distribution",
                                                    [segmentData.filter(item => item["Group name"] === this.state.selectedSegment)[0]["AgeData"].map(item => [item["AgeGroup"], item.Percentage])]
                                                )}
                                            </div>
                                        </div>
                                        <Hidden mdDown>
                                            <div
                                                className={"pieCharts"}
                                                style={
                                                    {
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        width: '100%',
                                                        height: '40%',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-evenly'

                                                    }
                                                }>
                                                <div style={{ height: '100%', width: '100%' }}>
                                                    {this.renderChart2(true, "Ad channel Presence",
                                                        channelProbability.filter(item => item.Media === this.state.selectedSegment.toLowerCase()).map(
                                                            row => [
                                                                ["TV", row.tv ? row.tv * 100 : 0],
                                                                ["Billboard", row.billboard ? row.billboard * 100 : 0],
                                                                ["Radio", row.radio ? row.radio * 100 : 0],
                                                                ["Print", row.printmedia ? row.printmedia * 100 : 0],
                                                                ["Radio", row.radio ? row.radio * 100 : 0]
                                                            ]
                                                        )
                                                    )}
                                                </div>
                                                <div style={{ height: '100%', width: '100%' }}>
                                                    {this.renderChart2(true, "Activity distribution",
                                                        segmentActivity.filter(item => item.segment.toLowerCase() === this.state.selectedSegment.toLowerCase()).map(
                                                            row => [
                                                                ["Commute", row.Commute ? row.Commute * 100 : 0],
                                                                ["Entertainment", row.Entertainment ? row.Entertainment * 100 : 0],
                                                                ["Fitness", row.Fitness ? row.Fitness * 100 : 0],
                                                                ["Hygiene", row.Hygiene ? row.Hygiene * 100 : 0],
                                                                ["Interactions", row.Interactions ? row.Interactions * 100 : 0],
                                                                ["Work", row.Work ? row.Work * 100 : 0]
                                                            ]
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </Hidden>
                                    </div>
                                }


                            </Grid>
                            {/* Customer segments content area (right column) */}

                            {
                                this.state.selectedSegment === '' || this.state.selectedSegment === undefined ?
                                    null
                                    :
                                    <Grid className={"rightColumn"} item xs={2} >
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly',
                                                height: '100%'
                                            }}
                                        >
                                            {/*Profile picture*/}
                                            <div>
                                                <img style={{ borderRadius: 'calc( 0.3vw + 0.5vh)', height: 'calc(2vw + 5vh)', width: 'calc(2vw + 5vh)', filter: 'grayscale(100%) opacity(0.85)', boxShadow: "0px 1px 5px 0px rgb(0, 0, 0), 0px 2px 2px 0px rgba(0, 0, 0, 0.29), 0px 3px 1px -2px rgba(0, 0, 0, 0.23)" }} src={this.state.selectedSegment === " " || this.state.selectedSegment === undefined ? null : segmentData.filter(a => a["Group name"] === this.state.selectedSegment)[0].Logo
                                                } alt="Beginnings group segment" />
                                            </div>
                                            {/*Percentage of US population*/}
                                            <div style={
                                                {

                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    margin: '2px 0'
                                                }
                                            }>
                                                <div style={{ fontFamily: 'Roboto', fontSize: 'calc(0.5vw + 1vh)', color: '#706c6c', fontWeight: 300 }}>
                                                    {this.state.selectedSegment === " " || this.state.selectedSegment === undefined ? null : segmentData.filter(a => a["Group name"] === this.state.selectedSegment)[0].Percentage}
                                                </div>
                                                <StyledDivider variant="middle" />
                                                <div style={{ fontFamily: 'Roboto', fontSize: "calc(0.45vw + 0.5vh)", color: '#706c6c', fontWeight: 300 }}>
                                                    of US
                                                </div>
                                            </div>

                                            {/*Percentag of group Married*/}
                                            <Hidden smDown>
                                                <div style={
                                                    {
                                                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                                        margin: '2px 0 7px', paddingBottom: '9%'
                                                    }
                                                }>

                                                    <div style={
                                                        {
                                                            fontSize: 'calc(0.45vw + 0.5vh)',
                                                            fontFamily: 'Roboto', fontWeight: 300
                                                        }
                                                    }>
                                                        {this.state.Married}% Married
                                        </div>

                                                    <div style={{ width: "8vw", height: '45px', background: "transparent" }}  >

                                                        {this.renderPie([
                                                            ["Married", this.state.Married
                                                            ],
                                                            ["Unmarried", 100 - this.state.Married
                                                            ]
                                                        ])}

                                                    </div>

                                                </div>
                                                <Divider light style={{
                                                    width: "calc(4vw + 4vh)",
                                                    height: "1px",
                                                    background: "#e5e5e5"
                                                }} />
                                            </Hidden>
                                            {/*List of most probable occupation*/}
                                            <div style={
                                                {
                                                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                                                    margin: '4% 0 14px 0'
                                                }
                                            }>
                                                <div style={
                                                    {
                                                        textAlign: 'left',
                                                        textDecoration: 'underline',
                                                        fontFamily: 'Roboto',
                                                        fontWeight: 300,
                                                        textDecorationColor: '#d0d0d085',
                                                        fontSize: 'calc(0.45vw + 0.5vh)'

                                                    }
                                                }>
                                                    Occupation
                                        </div>
                                                <div style={
                                                    {
                                                        fontSize: 'calc(0.45vw + 0.5vh)',
                                                        fontFamily: 'Roboto',
                                                        fontWeight: 100,
                                                        width: "100%",
                                                        textAlign: "left"
                                                    }
                                                }>
                                                    <ul style={
                                                        {
                                                            paddingLeft: '10px', margin: '3px 0', fontSize: 'calc(0.45vw + 0.3vh)'
                                                        }
                                                    }>
                                                        {this.state.selectedSegment === " " || this.state.selectedSegment === undefined ? null : segmentData.filter(a => a["Group name"] === this.state.selectedSegment)[0].Occupation.map(
                                                            item => <li>{item}</li>
                                                        )}

                                                    </ul>
                                                </div>
                                            </div>
                                            {/*Tyle of location: City ~ Rural ~ Downtown Metro ~ Suburbs*/}
                                            <div style={
                                                {
                                                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                                    margin: '2px 0'
                                                }
                                            }>
                                                <img style={{ borderRadius: 'calc( 0.3vw + 0.5vh)', height: 'calc(2vw + 5vh)', width: "calc(2vw + 5vh)", filter: 'grayscale(100%) opacity(0.70)' }} src={this.state.selectedSegment === " " || this.state.selectedSegment === undefined ? null : segmentData.filter(a => a["Group name"] === this.state.selectedSegment)[0].Location
                                                } alt="Location Placeholder" />
                                                <div style={
                                                    {
                                                        fontFamily: 'Roboto', fontSize: 'calc(0.5vw + 0.5vh)', color: 'rgb(112, 108, 108)', fontWeight: 300, margin: '2px 0 2px 0'
                                                    }
                                                }>
                                                    {this.state.selectedSegment === " " || this.state.selectedSegment === undefined ? null : segmentData.filter(a => a["Group name"] === this.state.selectedSegment)[0].LocationPlaceholder
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                            }
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

ConsumerSegmentsDialogue.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired
}

export default withStyles(styles)(ConsumerSegmentsDialogue);